import { render } from "./UiFullScreenLoader.vue?vue&type=template&id=f6ba2ff6&scoped=true&lang=pug"
const script = {}

import "./UiFullScreenLoader.vue?vue&type=style&index=0&id=f6ba2ff6&lang=sass&scoped=true"

import exportComponent from "D:\\Front\\project\\valeriya.artist\\valeriya.artist.admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6ba2ff6"]])

export default __exports__